module.exports = __webpack_public_path__ + "img/01宋雷.0f398e4c.jpg";